"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseViewport = exports.canUseEventListeners = exports.canUseDOM = void 0;
/**
 * @about In a Node.js environment (ex: Jest, Server-Side React)
 * `window` and `document` objects are typically undefined. These checks ensure
 * we don't throw errors when using required DOM elements.
 */

/**
 * Checks if the current environment is a browser with a DOM.
 * @type {boolean}
 */
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Checks if `window` object has `addEventListener` or `attachEvent` properties
 * @type {boolean}
 */
var canUseEventListeners = exports.canUseEventListeners = canUseDOM && Boolean(window.addEventListener || window.attachEvent);

/**
 * Checks if the `window` object has a screen property.
 * @type {boolean}
 */
var canUseViewport = exports.canUseViewport = canUseDOM && Boolean(window.screen);
//# sourceMappingURL=execution-environment.js.map